import {NotificationGroup} from "../entities/notificationGroup";
import {PersonalNotificationGroup} from "../../enums/notification";

export function isPersonalNotificationGroup(group: NotificationGroup): group is PersonalNotificationGroup {
    return Object
        .values(PersonalNotificationGroup)
        .includes(group as PersonalNotificationGroup);
}